/**
 * CableList Component - List of cables in sidebar
 */
import React, { useEffect } from 'react';
import { useProjectStore, useCableStore, usePoleStore } from '../../stores';
import { FiberList } from './FiberList';
import './CableList.css';

export const CableList: React.FC = () => {
  const { currentProject } = useProjectStore();
  const { cables, selectedCable, loading, fetchCables, setSelectedCable } = useCableStore();
  const { poles } = usePoleStore();

  useEffect(() => {
    if (currentProject) {
      fetchCables(currentProject.id);
    }
  }, [currentProject, fetchCables]);

  if (!currentProject) {
    return (
      <div className="cable-list-empty">
        <p>Nie je vybraný projekt</p>
        <p className="hint">Najprv vyberte projekt</p>
      </div>
    );
  }

  const getPoleName = (poleId: number) => {
    const pole = poles.find((p) => p.id === poleId);
    return pole?.name || `Stĺpik #${poleId}`;
  };

  const getAvailableFibers = (cable: any) => {
    if (!cable.fiber_assignments) return 0;
    return cable.fiber_assignments.filter((f: any) => !f.is_used).length;
  };

  return (
    <div className="cable-list">
      <div className="cable-list-header">
        <h3>Káble</h3>
        <span className="cable-count">{cables.length}</span>
      </div>

      {loading && cables.length === 0 ? (
        <div className="loading">Načítavajú sa káble...</div>
      ) : (
        <div className="cable-items">
          {cables.length === 0 ? (
            <div className="empty-state">
              <p>Zatiaľ žiadne káble</p>
              <p className="empty-state-hint">
                Pridajte káble z mapy
              </p>
            </div>
          ) : (
            cables.map((cable) => (
              <div
                key={cable.id}
                className={`cable-item ${
                  selectedCable?.id === cable.id ? 'active' : ''
                }`}
                onClick={() => setSelectedCable(cable)}
              >
                <div className="cable-item-icon">🔌</div>
                <div className="cable-item-content">
                  <div className="cable-item-route">
                    {getPoleName(cable.from_pole_id)} → {getPoleName(cable.to_pole_id)}
                  </div>
                  <div className="cable-item-details">
                    <span className="cable-length">
                      {cable.length_meters ? `${cable.length_meters}m` : 'N/A'}
                    </span>
                    <span className="cable-fibers">
                      {getAvailableFibers(cable)}/12 vlákien voľných
                    </span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {selectedCable && selectedCable.fiber_assignments && (
        <FiberList cable={selectedCable} />
      )}
    </div>
  );
};

